import Vue from 'vue';
import Vuex from 'vuex';
import authStore from '@/store/auth';
import user from '@/store/modules/user';
import course from '@/store/modules/course';
import train from '@/store/modules/train';
import help from '@/store/modules/help';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    course,
    train,
    help,
  },
  state: {
    auth: authStore.state,
  },
});
